import { ComponentType } from 'react';

import * as React from 'react';
import asyncRetry from 'async-retry';

const lazyRetry = <T extends ComponentType<any>>(factory: () => Promise<{ default: T }>) =>
  React.lazy(() => asyncRetry(factory, { retries: 5 }));

export default lazyRetry;
